import {
  GET_BEMOB_SETUP,
  GET_CHECKOUT_LANGUAGES,
  GET_BEMOB_COUNTRY,
  GET_USER_GROUP,
  GET_SHOPIFY_MENU_LIST,
  COLOR_CODE,
  POSTING_STORE,
  OWNER_STORE,
  PARAMETER_ERROR,
  GET_DOMAIN_LIST,
} from "../types";

const ParameterReducer = (state, action) => {
  switch (action.type) {
    case GET_BEMOB_SETUP:
      return { ...state, bemob_setup_list: action.payload };

    case GET_CHECKOUT_LANGUAGES:
      return { ...state, checkout_languages: action.payload };

    case GET_BEMOB_COUNTRY:
      return { ...state, bemob_country: action.payload };

    case GET_USER_GROUP:
      return { ...state, user_group: action.payload };

    case GET_SHOPIFY_MENU_LIST:
      return { ...state, shopify_menu_list: action.payload };

    case GET_DOMAIN_LIST:
      return { ...state, domain_list: action.payload };

    case COLOR_CODE:
      return { ...state, color_code: action.payload };

    case POSTING_STORE:
      return { ...state, posting_store: action.payload };

    case OWNER_STORE:
      return { ...state, owner_store: action.payload };

    case PARAMETER_ERROR:
      return { ...state, error: action.payload };

    default:
      return state;
  }
};

export default ParameterReducer;
